/**
 * SDK Exceptions matching PHP SDK structure
 */

export class DreamscapeException extends Error {
  constructor(message: string, public statusCode?: number) {
    super(message);
    this.name = 'DreamscapeException';
  }
}

export class AuthenticationException extends DreamscapeException {
  constructor(message: string = 'Authentication is required') {
    super(message, 401);
    this.name = 'AuthenticationException';
  }
}

export class BadRequestException extends DreamscapeException {
  constructor(
    message: string = 'Bad request',
    public validationErrors?: Record<string, string> | string[]
  ) {
    super(message, 400);
    this.name = 'BadRequestException';
  }
}

export class PaymentRequiredException extends DreamscapeException {
  constructor(
    message: string = 'Payment is required',
    public paymentDetails?: { totalPrice?: string; balance?: string }
  ) {
    super(message, 402);
    this.name = 'PaymentRequiredException';
  }
}

export class NotFoundException extends DreamscapeException {
  constructor(
    message: string = 'Not found',
    public resourceType?: string,
    public resourceId?: string | number
  ) {
    super(message, 404);
    this.name = 'NotFoundException';
  }

  /**
   * Get a user-friendly error message
   */
  getUserMessage(): string {
    if (this.resourceType && this.resourceId) {
      return `${this.resourceType} with ID "${this.resourceId}" not found`;
    }
    if (this.resourceType) {
      return `${this.resourceType} not found`;
    }
    return this.message;
  }
}

export class InternalServerErrorException extends DreamscapeException {
  constructor(message: string = 'Internal server error', public endpoint?: string) {
    super(message, 500);
    this.name = 'InternalServerErrorException';
  }
}

export class InvalidResponseException extends DreamscapeException {
  constructor(message: string = 'Invalid response from server') {
    super(message);
    this.name = 'InvalidResponseException';
  }
}

